module.exports = __webpack_public_path__ + "img/wordpress.482afdba.png";